import React from 'react'
import styled from '@emotion/styled'
import { Dialog, DialogAdornment, DialogWindow, DialogHeader, DialogBody } from '@ticketswap/solar'
import { CloseAlt } from '@ticketswap/comets'

export const EmbedContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const SecureSwapVideoDialog = ({ t, children, ...props }) => {
  return (
    <Dialog {...props}>
      {({ hide, getToggleProps, getWindowProps }) => (
        <>
          {children({ getToggleProps, hide })}
          <DialogWindow {...getWindowProps()}>
            <DialogHeader>
              {t('common:secureSwapVideoDialog.title')}
              <DialogAdornment right>
                <button onClick={hide}>
                  <CloseAlt size={24} />
                </button>
              </DialogAdornment>
            </DialogHeader>
            <DialogBody>
              <EmbedContainer>
                <iframe
                  title="Secure Swap video"
                  src="https://www.youtube.com/embed/gM41PC9CuMo"
                  frameBorder="0"
                  allowFullScreen
                />
              </EmbedContainer>
            </DialogBody>
          </DialogWindow>
        </>
      )}
    </Dialog>
  )
}

export default SecureSwapVideoDialog
